import React, { useEffect, useRef, useState } from "react";
import { apiWrapper } from "../../apis/CommonApi";
import * as communityApi from "../../apis/CommunityApi";
import PageHeader from "../../components/PageHeader";
import { getDateTime } from "../../utils/date";
import { useNavigate } from "react-router-dom";

export default function NoticeListComponent() {
    const itemsPerPage = 100;
    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [page, setPage] = useState(1);
    const [next, setNext] = useState(null);
    const scrollRef = useRef();
    const pageRef = useRef(page);
    const nextRef = useRef(next);

    useEffect(() => {
        const scrollWrap = scrollRef.current;

        const handleScroll = () => {
            if (scrollWrap.scrollTop + scrollWrap.clientHeight >= scrollWrap.scrollHeight - 5) {
                if (nextRef.current) {
                    getData(pageRef.current + 1);
                }
            }
        }

        scrollWrap.addEventListener('scroll', handleScroll);

        getData(page);

        return () => {
            scrollWrap.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        nextRef.current = next;
    }, [next]);

    const getData = (page) => {
        apiWrapper(async () => {
            const { status, data } = await communityApi.getNoticePostList("", "", page, itemsPerPage);
            if (status === true) {
                setDataSource((prevDataSource) => {
                    if (prevDataSource.some(item => item.page === page)) {
                        return prevDataSource;
                    }

                    return [
                        ...prevDataSource,
                        {
                            page: page,
                            results: data.results,
                        }
                    ]
                });

                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }
        });
    }

    const handleItemClick = (id) => {
        navigate(`/notice/${id}/`);
    }

    return (
        <section class="mbSection">
            <PageHeader isBlack={false} title="공지사항" isUseMenu={false} />
            <div class="container pb-40">
                <div class="tableList noticelist">
                    <div class="config-row title-row">
                        <div class="title-txt config-id">순번</div>
                        <div class="title-txt config-title">제목</div>
                        <div class="title-txt config-date">등록일시</div>
                        <div class="title-txt config-count">조회</div>
                    </div>
                    <div ref={scrollRef} class="config-row-wrap scroll-wrap type-273">
                        {dataSource &&
                            dataSource.length > 0 &&
                            dataSource.map((pageItem) => {
                                if (pageItem.results.length > 0) {
                                    return pageItem.results.map((item, index) => (
                                        <div class="config-row" onClick={() => handleItemClick(item.id)}>
                                            <div class="config-id">
                                                <p class="title">{item.id}</p>
                                            </div>
                                            <div class="config-title">
                                                <p class="title">{item.title}</p>
                                            </div>
                                            <div class="config-date">
                                                <p class="date-title">{getDateTime(new Date(item.createdDate))}</p>
                                            </div>
                                            <div class="config-count">
                                                <p class="title">{item.viewsCount}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            })}
                    </div>
                </div>
            </div>
        </section>
    );
}
